import styled from 'styled-components';

export const Container = styled.div`
  padding: 4.5em 0 0;
  width: 100%;
  max-width: ${props => props.theme.maxWidth};
  margin: 0 auto;
  left: -100%;
`;

export const Title = styled.h1`
  font-family: Pacifico;
  font-size: 1.2em;
  font-weight: 400;
  margin: 0;
  padding: 1em;
  @media (min-width: 768px) {
    font-size: 3em;
  }
`;

export const SubTitle = styled.h4`
  font-size: 1.25rem;
  font-weight: 400;
  margin-left: auto;
  padding: 1em;
  float: right;
  display: none;
  small {
    display: block;
    font-size: 0.75em;
    color: #777;
  }
  @media (min-width: 768px) {
    display: block;
  }
`;



// WEBPACK FOOTER //
// ./src/components/HomePage/Styles.js